// courseReducer.js
import {
    FETCH_COURSES_REQUEST,
    FETCH_COURSES_SUCCESS,
    FETCH_COURSES_FAILURE,
    ADD_COURSE_REQUEST,
    ADD_COURSE_SUCCESS,
    ADD_COURSE_FAILURE,
    UPDATE_COURSE_REQUEST,
    UPDATE_COURSE_SUCCESS,
    UPDATE_COURSE_FAILURE,
    DELETE_COURSE_REQUEST,
    DELETE_COURSE_SUCCESS,
    DELETE_COURSE_FAILURE,
    FETCH_COURSES_DROPDOWN_REQUEST,
  FETCH_COURSES_DROPDOWN_SUCCESS,
  FETCH_COURSES_DROPDOWN_FAILURE,
  } from './actionTypes';
  
  const initialState = {
    courses: [],
    dropdownCourses: [],
    loading: false,
    error: null,
  };
  
  const courseReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_COURSES_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
  
      case FETCH_COURSES_SUCCESS:
        return {
          ...state,
          loading: false,
          courses: action.payload,
        };
  
      case FETCH_COURSES_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      case ADD_COURSE_REQUEST:
      case UPDATE_COURSE_REQUEST:
      case DELETE_COURSE_REQUEST:
        return {
          ...state,
          loading: true,
        };
  
      case ADD_COURSE_SUCCESS:
        return {
          ...state,
          loading: false,
          courses: {
            ...state.courses,
            data: [...(state.courses?.data || []), action.payload?.data],
          },
        };
  
      case ADD_COURSE_FAILURE:
      case UPDATE_COURSE_FAILURE:
      case DELETE_COURSE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      case UPDATE_COURSE_SUCCESS:
        return {
          ...state,
          loading: false,
          courses: {
            ...state.courses,
            data: state.courses?.data?.map((item) =>
              item?._id === action.payload?.data?._id ? action.payload.data : item
            ),
          },
        };
  
      case DELETE_COURSE_SUCCESS:
        return {
          ...state,
          loading: false,
          courses: {
            ...state.courses,
            data: state.courses?.data?.filter(
              (item) => item?._id !== action.payload?.data?._id
            ),
          },
        };

        case FETCH_COURSES_DROPDOWN_REQUEST:
  return {
    ...state,
    loading: true,
    error: null,
  };

case FETCH_COURSES_DROPDOWN_SUCCESS:
  return {
    ...state,
    loading: false,
    dropdownCourses: action.payload, // store dropdown data separately
  };

case FETCH_COURSES_DROPDOWN_FAILURE:
  return {
    ...state,
    loading: false,
    error: action.payload,
  };
  
      default:
        return state;
    }
  };
  
  export default courseReducer;
  